import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Edit, Trash2, Plus } from 'lucide-react';
import './RegistrationtypeList.css';
// const url = import.meta.env.VITE_BACKEND_URL;
const url = process.env.REACT_APP_BACKEND_URL;

const RegistrationtypeList = () => {
  const [registrationtype, setRegistrationtype] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchRegistrationtype = async () => {
      try {
        const response = await axios.get(`${url}/api/registrationtype`);
        setRegistrationtype(response.data.data);
      } catch (err) {
        setError(err.response?.data?.message || 'Failed to fetch Registration Type');
      } finally {
        setLoading(false);
      }
    };

    fetchRegistrationtype();
  }, []);

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${url}/api/registrationtype/${id}`);
      setRegistrationtype(registrationtype.filter(registrationtype => registrationtype._id !== id));
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to delete Registration Type');
    }
  };

  if (loading) return <div className="loading">Loading Registration Type...</div>;
  if (error) return <div className="error">Error: {error}</div>;

  return (
    <div className="countries-container">
      <div className="header">
        <h2>Registration Type List</h2>
        <button 
          onClick={() => navigate('/AddRegistrationtype')}
          className="add-button"
        >
          <Plus size={16} /> Add Registration Type
        </button>
      </div>

      <table className="countries-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Amount</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {registrationtype.map(registrationtype => (
            <tr key={registrationtype._id}>
              <td>{registrationtype.name}</td>
              <td>{registrationtype.amount}</td>
              <td className="actions">
                <button 
                  onClick={() => navigate(`/registrationtype/edit/${registrationtype._id}`)}
                  className="edit-btn"
                >
                  <Edit size={14} />
                </button>
                {/* <button 
                  onClick={() => handleDelete(registrationtype._id)}
                  className="delete-btn"
                >
                  <Trash2 size={14} />
                </button> */}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default RegistrationtypeList;